import React from 'react'
import JuniorVideoWelcome from './sections/JuniorVideoWelcome/JuniorVideoWelcome'
import JuniorVideoPresentations from './sections/JuniorVideoPresentations/JuniorVideoPresentations'
import JuniorVideoLinks from './sections/JuniorVideoLinks/JuniorVideoLinks'

const SundaySchoolJunior = () => {
  return (
    <>
      <JuniorVideoWelcome/>
      <JuniorVideoLinks/>
      <JuniorVideoPresentations/>
    </>
  )
}

export default SundaySchoolJunior
